var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { autoinject } from 'aurelia-dependency-injection';
var signalR = require("./signalr.min.js");
var SignalClientService = /** @class */ (function () {
    function SignalClientService() {
        this._connected = false;
        this._reconnectCallbacks = [];
    }
    SignalClientService.prototype.stopListener = function () {
        if (this._connected && this._connection) {
            this._connection.stop();
        }
    };
    SignalClientService.prototype.subscribe = function (methodName, callback) {
        if (this._connection) {
            this._connection.on(methodName, callback);
        }
    };
    SignalClientService.prototype.unsubscribe = function (methodName, callback) {
        if (this._connection) {
            this._connection.off(methodName, callback);
        }
    };
    SignalClientService.prototype.notifyServer = function (hub, method, data) {
        this._connection.send('InvokeServerFunction', { interceptorName: hub, functionName: method, data: data });
    };
    SignalClientService.prototype.onReconnected = function (callback) {
        this._reconnectCallbacks.push(callback);
    };
    SignalClientService.prototype.offReconnected = function (callback) {
        var index = this._reconnectCallbacks.indexOf(callback);
        this._reconnectCallbacks.slice(index, 1);
    };
    SignalClientService.prototype.startListener = function () {
        return __awaiter(this, void 0, void 0, function () {
            var getConnection, newConnection;
            var _this = this;
            return __generator(this, function (_a) {
                getConnection = function () {
                    var connection = new signalR.HubConnectionBuilder().withUrl("/genericsr").build();
                    var onClose = function (e) {
                        console.log("SignalR Connection Closed " + _this._connected);
                        var delay = function (time) {
                            return new Promise(function (resolve) {
                                setTimeout(resolve, time);
                            });
                        };
                        var reconnect = function (interval) {
                            // Create a new connection (it can't restart)
                            newConnection = getConnection();
                            return newConnection.start().then(function () {
                                var e_1, _a;
                                console.log("signalR connection re-opened");
                                Object.keys(_this._connection.methods).forEach(function (key) {
                                    // re-subscribe signalr
                                    _this._connection.methods[key].forEach(function (func) {
                                        newConnection.on(key, func);
                                    });
                                });
                                try {
                                    // call reconnected event
                                    for (var _b = __values(_this._reconnectCallbacks), _c = _b.next(); !_c.done; _c = _b.next()) {
                                        var func = _c.value;
                                        func();
                                    }
                                }
                                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                                finally {
                                    try {
                                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                                    }
                                    finally { if (e_1) throw e_1.error; }
                                }
                                _this._connection = newConnection;
                            }).catch(function (err) {
                                console.log("Error trying to re-open signalR connection, waiting ".concat(interval / 1000, " sec before retrying..."));
                                return delay(interval).then(function () {
                                    return reconnect(interval);
                                });
                            });
                        };
                        if (e) {
                            console.log("signalR connection closed with message \"".concat(e.message, "\""));
                        }
                        else {
                            console.log("signalR connection closed");
                        }
                        reconnect(5000);
                    };
                    connection.onclose(onClose);
                    return connection;
                };
                newConnection = getConnection();
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        newConnection.start().then(function () {
                            console.log("signalR connection opened");
                            _this._connection = newConnection;
                            resolve();
                        }).catch(function (err) {
                            console.log("Error opening SignalR websocket connection: ".concat(err ? err.message : ''));
                            reject();
                        });
                    })];
            });
        });
    };
    SignalClientService = __decorate([
        autoinject
    ], SignalClientService);
    return SignalClientService;
}());
export { SignalClientService };
var SignalFunctions = /** @class */ (function () {
    function SignalFunctions() {
    }
    SignalFunctions.refreshData = "refreshData";
    SignalFunctions.activityLogsUpdated = "activityLogsUpdated";
    SignalFunctions.pushedNotification = "pushedNotification";
    SignalFunctions.deletedNotification = "deletedNotification";
    SignalFunctions.videoCallRequested = "videoCallRequested";
    SignalFunctions.videoCallAccepted = "videoCallAccepted";
    SignalFunctions.videoCallEnded = "videoCallEnded";
    SignalFunctions.onPlayerBalance = "onPlayerBalance";
    return SignalFunctions;
}());
export { SignalFunctions };
